/** OpenAPI / backend `FieldDefinition.dataType` for calendar date (no time-of-day). */
export const API_DATE_ONLY_DATA_TYPE = "date" as const;

/** OpenAPI / backend `FieldDefinition.dataType` for time-of-day only. */
export const API_TIME_ONLY_DATA_TYPE = "time" as const;

/** OpenAPI / backend `FieldDefinition.dataType` for date and time together. */
export const API_DATETIME_DATA_TYPE = "datetime" as const;
